import React from 'react'
import { IProps } from './index'
import { RichText } from 'marketing-site/src/library/elements/RichText'
import { mq } from 'marketing-site/src/library/utils'
import { Text } from 'marketing-site/src/library/elements/Text'
import { Image } from 'marketing-site/src/library/elements/Image'
import { TextLink } from 'marketing-site/src/library/elements/TextLink'
import useTranslate from '../../hooks/useTranslate'

export function Details(props: IProps) {
  const { translate } = useTranslate()
  return (
    <div className="demo__details-wrap">
      <div className="demo__details">
        <div className="demo__presenter">
          <div className="demo__section-title">
            <Text size="lg-eyebrow">{translate('Hosted By')}</Text>
          </div>
          <div className="demo__presenter-wrap">
            {props.presenter.image && (
              <div className="demo__presenter-wrap--avatar">
                <Image url={props.presenter.image} />
              </div>
            )}
            <div className="demo__presenter-wrap--info">
              <div>
                <Text size="caption+">{props.presenter.name}</Text>
              </div>
              {props.presenter.title && (
                <div>
                  <Text size="caption">{props.presenter.title}</Text>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="demo__duration">
          <div className="demo__section-title">
            <Text size="lg-eyebrow">{translate('Duration')}</Text>
          </div>
          {props.wistia?.duration} {translate('min')}
        </div>
        {props.resources.length > 0 && (
          <div className="demo__resources">
            <div className="demo__section-title">
              <Text size="body+">{translate('Resources')}</Text>
            </div>
            {props.resources.map((resource) => {
              return (
                <div className="demo__resource" key={resource.label}>
                  <TextLink url={resource.url}>
                    <Text size="body">{resource.label}</Text>
                  </TextLink>
                </div>
              )
            })}
          </div>
        )}
        <div className="demo__details-main">
          {props.description ? <RichText document={props.description} /> : null}
        </div>
      </div>
      <style jsx>
        {`
          .demo__details-wrap {
            display: grid;
            grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
            padding: 70px 0px;
          }

          .demo__details {
            display: grid;
            grid-column: content;
            grid-template-columns: [sidebar] 4fr [main] 8fr;
            grid-template-rows: auto auto 1fr;
            max-width: $container-max-width;
            margin: 0 auto;
          }

          .demo__section-title {
            margin-bottom: 15px;
          }

          .demo__details-main,
          .demo__presenter,
          .demo__duration,
          .demo__resources {
            grid-column: sidebar / span 2;
          }

          .demo__duration,
          .demo__resources,
          .demo__details-main {
            margin-top: 30px;
          }

          .demo__presenter-wrap {
            display: flex;

            &--avatar {
              max-width: 53px;
              padding-right: 1em;

              :global(img) {
                border-radius: 100%;
                max-width: 100%;
              }
            }
          }

          .demo__resource {
            @include focusable;
            display: block;
            padding: 6px 0;
            color: $black-legacy;
            text-decoration: none;
            position: relative;
            outline: none;

            &:hover {
              text-decoration: underline;
            }
          }

          .demo__details-main {
            :global(h2),
            :global(h3),
            :global(h4) {
              font-weight: 400;
              font-size: 16px;
              margin-bottom: 20px;
            }

            :global(li) {
              background-image: none;
              list-style: disc;
              padding-left: 0;
              margin-left: 20px;
            }

            :global(ul li::before) {
              background-image: none;
            }
          }

          @media (${mq.tablet}) {
            .demo__presenter,
            .demo__duration,
            .demo__resources {
              grid-column: sidebar;
            }

            .demo__duration {
              grid-row: 2;
            }

            .demo__resources {
              grid-row: 3;
              display: block;
            }

            .demo__details-main {
              grid-column: main;
              grid-row: span 3;
              margin-top: 0;

              :global(h2),
              :global(h3),
              :global(h4) {
                font-size: 26px;
                margin-bottom: 30px;
              }
            }
          }
        `}
      </style>
    </div>
  )
}
